import { getConfig } from "../../config";

const BCK_AVA_API = getConfig().BCK_AVA_V1_URL;

const __post = async (url, payload) => {
  try {
    return await fetch(url, {
      method: 'post',
      body : payload,
      // mode: 'no-cors'
    })
    .then(resp => {
      if (!resp.ok || resp.status >= 400) throw resp.json()
      return resp.json()
    })
    .catch(error => {
        throw error;
    })
  } catch (err) {
    throw err
  }
}

const __patch = async (url, payload) => {
  try {
    return await fetch(url, {
      method: 'PATCH',
      body : payload,
      //mode: 'no-cors'
    })
    .then(resp => {
      if (!resp.ok || resp.status >= 400) throw resp.json()
      return resp.json()
    })
    .catch(error => {
        throw error;
    })
  } catch (err) {
    throw err
  }
}

const __delete = async (url, payload) => {
  try {
    return await fetch(url, {
      method: 'DELETE',
      body : payload,
      //mode: 'no-cors'
    })
    .then(resp => {
      if (!resp.ok || resp.status >= 400) throw resp.json()
      return resp.json()
    })
    .catch(error => {
        throw error;
    })
  } catch (err) {
    throw err
  }
}

const __get = async (url) => {
  try {
    return await fetch(url)
    .then(resp => {
      if (!resp.ok || resp.status >= 400) {
        throw resp.json()
      }
      if (resp.status === 204) { // no content
        return null
      } 
      return resp.json()
    })
    .catch(error => {
        throw error
    })
  } catch (err) {
    throw err
  }
}


/***************************/
/***   ANALYTICS CALLS   ***/
/***************************/

export const fetchLiteAnalytics = async (user_id, site_id, options) => {
  const payload = { user_id, site_id, options };
  return __post(BCK_AVA_API + `activity/query/lite`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}

export const fetchSiteAvaAnalytics = async (user_id, site_id, options) => {
  const payload = { user_id, site_id, options };
  return __post(BCK_AVA_API + `activity/query`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}

export const fetchSiteTrendingReport = async (user_id, site_id, options) => {
  const payload = { user_id, site_id, options };
  return __post(BCK_AVA_API + `trending/query`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}

export const postLightsailConnection = async (user_id, site_id, lightsail) => {
  const payload = { user_id, site_id, lightsail };
  return __post(BCK_AVA_API + `lightsail/connect`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}

export const postAvaApiChat = async (user_id, message, history) => {
  const payload = { user_id, message, history };
  return __post(BCK_AVA_API + `inputs/api`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}

export const postContentSubmission = async (user_id, site_id, content, options) => {
  const payload = { user_id, site_id, content, options };
  return __post(BCK_AVA_API + `content/submit-content`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}

export const postContentPublishRequest = async (user_id, site_id, content_id, options) => {
  const payload = { user_id, site_id, content_id, options };
  return __post(BCK_AVA_API + `content/publish-content`, JSON.stringify(payload))
  .then(response => {
    if (response && response.data) return response.data;
    return response;
  })
  .catch(err => { throw err });
}
